import React, {Component} from 'react'
import {graphql} from 'react-apollo'
// import Datetime from 'react-datetime'
import DatePicker from 'react-datepicker'
// CSS Modules, react-datepicker-cssmodules.css
import 'react-datepicker/dist/react-datepicker-cssmodules.css';

// import PropTypes from 'prop-types'
import cn from 'classnames'
import get from 'lodash/get'
import moment from 'moment'
// import 'react-datetime/css/react-datetime.css'

import Channels from '../Channels'

import CREATE_BOARD_MUTATION from '../../graphql/mutations/CreateBoardMutation.graphql'
import {getUser} from '../../utils'

import Form from '../Form'

const MODAL_ID = 'createBoardModal'
const MODAL_LABEL_ID = 'createBoardLabel'


class CreateBoard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            topic: "",
            channel: "",
            // closeOption: "192",
            remindOption: "60",
            channelId: "",
            channelName: "",
            participantOption: "0",
            notifyOption: "app",
            description: "",
            user: getUser(),
            closeDate: null,
            minTime: this.calculateMinTime(new Date()),
            // isValidated: false
        }
    }

    handleSubmitAndCloseModal = () => {
        var val = this.handleBoardCreate();
        // console.log("handleSubmitAndCloseModal:" + val);
        var val2 = this.handleCloseModal();
        return val;
    }

    handleBoardCreate = async () => {
        //console.log('handleBoardCreate');
        // e.preventDefault();
        // alert(JSON.stringify(this.state))
        // console.log(this.props.board.uuid)

        await this.props.mutate({
            variables: {
                // name: this.props.name,
                // title: this.props.title,
                // description: this.props.description,
                // name: this.state.name,
                // title: this.state.title,
                // description: this.state.description,

                userUuid: this.state.user.uuid,
                slackUserId: this.state.user.slackId,
                teamId: this.state.user.organization.teamId,

                topic: this.state.topic,
                channelId: this.state.channelId,
                channelName: this.state.channelName,
                // closeOption: this.state.closeOption,
                remindOption: this.state.remindOption,
                closeDate: this.state.closeDate,
                participantOption: this.state.participantOption,
                notifyOption: this.state.notifyOption,
                description: this.state.description,
            },
        })
    }

    handleOpenModal = () => {
        this.setState({
            showModal: true,
            // date: this.props.board.submissionEndDate,
            // nickName: getUser().slackRealName,
            // title: '',
            // description: '',

        })
    }

    handleCloseModal = () => {
        //console.log(this.props.onCloseRefreshHandler)
        // this.props.onCloseRefreshHandler({variables: { fetchPolicy: 'cache-and-network' }})

        setTimeout(() => {
            this.props.onCloseRefreshHandler()
        }, 1000);

        this.setState({
            showModal: false,
        })
        // this.props.onCloseRefreshHandler()
    }

    handleBackdropClick = e => {
        if (get(e, 'target.id') === MODAL_ID) {
            this.handleCloseModal()
        }
    }


    // handleCloseOptionChange(event) {
    //     console.log('handleCloseOptionChange:'+event.target.value);
    //     this.setState({closeOption: event.target.value})
    // }

    handleremindOptionChange(event) {
        console.log('handleremindOptionChange:'+event.target.value);
        this.setState({remindOption: event.target.value})
    }


    handleParticipantOptionChange(event) {
        this.setState({participantOption: event.target.value})
    }

    handleNotifyOptionChange(event) {
        this.setState({notifyOption: event.target.value})
    }

    handleTopicChange(event) {
        this.setState({topic: event.target.value})
    }

    // onChange = (e) => {
    //     this.setState({ [e.target.name]: e.target.value });
    // }

    calculateMinTime = date => {
        let isToday = moment(date).isSame(moment(), 'day');
        if (isToday) {
            // console.log('handleDateChange isToday', date);
            let nowAddTwoHours = moment(new Date()).add({hours: 1.5}).toDate();
            return nowAddTwoHours;
        }
        return moment().startOf('day').toDate(); // set to 12:00 am today
    }

    handleDateChange = date => {
        // console.log('handleDateChange event date', date)
        // console.log('handleDateChange closeDate', this.state.closeDate)
        this.setState({
            closeDate: date,
            minTime: this.calculateMinTime(date),
        });
    }

    handleChannelChange(event) {
        // console.log('event.target.name:'+event.target.name);
        // console.log('event.target.value'+event.target.value);
        let channel_obj = JSON.parse(event.target.value);
        // console.log(channel_obj);
        // console.log(channel_obj['id']);
        // console.log(channel_obj['name']);
        this.setState({
            channelId: channel_obj['id'],
            channelName: channel_obj['name'],
        })
    }

    handleDescriptionChange(event) {
        this.setState({description: event.target.value})
    }

    componentDidUpdate() {
        document.body.classList.toggle('modal-open', this.state.showModal)
    }

    render() {
        const {showModal} = this.state
        const {board, isStartButton} = this.props

        return (
            <div className="">

                <div className={isStartButton ? 'text-center' : 'text-left'}>
                    <button className="btn btn-primary" onClick={this.handleOpenModal}>
                        {/*<i className="fa fa-plus-square pr-1"/>Start*/}
                        {/*<i className="fa fa-plus pr-1"/>*/}
                        Start Session
                    </button>
                </div>

                <div
                    className={cn('modal fade', {show: showModal})}
                    id={MODAL_ID}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby={MODAL_LABEL_ID}
                    aria-hidden="true"
                    style={{display: showModal ? 'block' : 'none'}}
                    onClick={this.handleBackdropClick}
                >
                    <div className="modal-dialog text-left" role="document">
                        <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title" id={MODAL_LABEL_ID}>
                                        <strong>Start Session</strong>
                                    </h5>
                                    <button onClick={this.handleCloseModal} className="close" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            <Form onValidateHandler={this.handleSubmitAndCloseModal}>
                                <div className="modal-body">
                                    {/*<Form submit={this.handleBoardCreate}>*/}
                                    {/*<Form onValidateHandler={this.handleSubmitAndCloseModal}>*/}
                                        <div className="form-group">
                                            <label htmlFor="topic"><strong>Session Name</strong></label>
                                            <input id="topic" name="topic" required={true} type="text"
                                                   minLength={2}
                                                   maxLength={128}
                                                   className="form-control" value={this.state.topic}
                                                   onChange={this.handleTopicChange.bind(this)}></input>
                                        </div>

                                    <div className="form-group">
                                        <label htmlFor="channel" className=""><strong>Public Slack Channel</strong></label>
                                        {/*<input id="channel" placeholder="#" required="true" type="text" className="form-control" value={this.state.channel} onChange={this.handleChannelChange.bind(this)}></input>*/}
                                        <Channels modalVisibility={this.state.showModal} onChannelSelected={this.handleChannelChange.bind(this)}/>
                                        {/*<div className="invalid-feedback">Channel Name is required!</div>*/}
                                    </div>


                                    <div className="form-group">

                                        {/*<label htmlFor="closeOption"><strong>Public Slack Channel & Session End Time</strong></label>*/}

                                        <div className="input-group">

                                            <div className="d-flex flex-column">
                                                <label htmlFor="closeDate" className=""><strong>Session Closing Time</strong></label>
                                                {/* config options: https://reactdatepicker.com*/}
                                                <DatePicker
                                                    // customInput={<Input />}
                                                    onChange={this.handleDateChange}
                                                    selected={this.state.closeDate}
                                                    minDate={new Date()}
                                                    minTime={this.state.minTime}
                                                    // maxTime={this.state.maxTime}
                                                    maxTime={moment().endOf('day').toDate()} // set to 23:59 pm today
                                                    timeIntervals={60}
                                                    dateFormat="MMM d, yyyy h:mm aa"
                                                    timeFormat="HH:mm"
                                                    // timeFormat="h:mm aa"
                                                    timeCaption="Time"
                                                    className="form-control"
                                                    // todayButton={"Today"}
                                                    showTimeSelect
                                                    required
                                                >
                                                </DatePicker>
                                            </div>

                                            <div className="mr-3"></div>

                                            <div className="d-flex flex-column">

                                                <label htmlFor="remindOption"><strong>Remind Channel Before Closing</strong></label>
                                                <select className="form-control" id="remindOption" value={this.state.remindOption}
                                                        onChange={this.handleremindOptionChange.bind(this)}>
                                                    <option value="0">No Reminder</option>
                                                    {/*<option value="30" selected="true">30 minutes before</option>*/}
                                                    <option value="60">1 hour before</option>
                                                </select>
                                            </div>

                                        </div>

                                    </div>

                                        <div className="form-group">
                                            <label htmlFor="participantOption"><strong>Participant
                                                Questions</strong></label>
                                            <select className="form-control" id="participantOption"
                                                    value={this.state.participantOption}
                                                    onChange={this.handleParticipantOptionChange.bind(this)}>
                                                <option value="0">Allow Anonymous & Auto Approve</option>
                                                <option value="1">Allow Anonymous & Moderate</option>
                                                <option value="2">Require Name & Auto-Approve</option>
                                                <option value="3">Require Name & Moderate</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="notifyOption"><strong>Notify Channel Members Session Has Started</strong></label>
                                            <select className="form-control" id="notifyOption"
                                                    value={this.state.notifyOption}
                                                    onChange={this.handleNotifyOptionChange.bind(this)}>
                                                <option value="app">App Notification (to all channel members)</option>
                                                <option value="here">@here (everyone active in channel)</option>
                                                <option value="channel">@channel (everyone in channel)</option>
                                                <option value="none">No Notification (will post a message only)</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="description" className=""><strong>Description</strong><span
                                                className="text-muted"> (Optional)</span></label>
                                            <textarea rows="1" name="description" id="description" placeholder=""
                                                      type="textarea" className="form-control"
                                                      value={this.state.description}
                                                      onChange={this.handleDescriptionChange.bind(this)}></textarea>
                                        </div>
                                    <div className="mb-2">
                                        <label className="text-muted">
                                            <i className="fa fa-info-circle"/> Want to use a private channel? - type <span className="jelly-color-danger jelly-background-color">/jellyfish</span> in the channel.
                                        </label>
                                    </div>

                                </div>
                                <div className="modal-footer text-muted">
                                    <button className="btn btn-secondary jelly-modal-footer-btn-secondary" type="button" onClick={this.handleCloseModal}>Cancel</button>
                                    <span>  </span>
                                    <button className="btn btn-primary" type="submit">Create</button>
                                </div>
                            </Form>

                        </div>
                    </div>
                </div>
                {showModal && <div className="modal-backdrop fade show"/>}
            </div>
        )
    }
}

// CreateBoard.propTypes = {
//   // title: PropTypes.string,
//   // description: PropTypes.string,
//   // name: PropTypes.string,
//   user: PropTypes.shape({
//       uuid: PropTypes.string.isRequired,
//       allowAnonymous: PropTypes.bool.isRequired
//   }),
//     onCloseRefreshHandler: PropTypes.func.isRequired,
// }

export default graphql(CREATE_BOARD_MUTATION)(CreateBoard)



// WEBPACK FOOTER //
// ./src/components/Board/CreateBoard.jsx